<template>
  <div class="order_wrap">
    <div class="order_head">
      <h5>최근 주문내역</h5>
      <p>최근 30일 동안의 주문 건 기준입니다.</p>
      <a href="/mypage/order-list">전체보기</a>
    </div>
    <div class="order_body">
      <div class="tbl_wrap">
        <table>
          <caption>
            최근 주문내역
          </caption>
          <colgroup>
            <col style="width: 20%" />
            <col style="width: 40%" />
            <col style="width: 20%" />
            <col style="width: 15%" />
            <col style="width: 10%" />
            <col style="width: 15%" />
          </colgroup>
          <thead>
            <tr>
              <th>주문일자<br />(주문번호)</th>
              <th>상품명</th>
              <th>판매금액</th>
              <th>행사장</th>
              <th>기부화환</th>
              <th>비 고</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="invitation in invitations"
              :key="invitation.invitationSeq"
            >
              <td>
                <div class="order_date">{{ invitation.createDate }}</div>
                <div class="product_num">({{ invitation.orderNum }})</div>
              </td>
              <td>
                <div class="product_info">
                  <div class="product_photo">
                    <img
                      :src="
                        invitation.filePath
                          ? $getImgUrl(invitation.filePath)
                          : require('../../assets/images/common/campaign_img_01.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="product_tit">
                    <p v-if="invitation.useCampaign">
                      [{{ invitation.categoryName }}]
                    </p>
                    <div>
                      {{
                        invitation.useCampaign
                          ? invitation.campaignName
                          : "기부화환 미적용"
                      }}
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="product_price">
                  {{
                    invitation.campaignAmount === 0
                      ? "-"
                      : $addComma(invitation.campaignAmount) + "원"
                  }}
                </div>
              </td>
              <td>
                <div class="place">
                  {{ invitation.eventLocationName }}
                  <span>({{ invitation.eventLocationDtl }})</span>
                </div>
              </td>
              <td>
                <div class="count">10</div>
              </td>
              <td>
                <a
                  v-bind:href="'/invitation/' + invitation.orderNum"
                  class="btn_view"
                  target="_blank"
                  >{{ invitation.isWedding ? "청첩장" : "부고장" }} 보기</a
                >
                <a
                  @click="openReviewModal(invitation.orderNum)"
                  v-if="invitation.useCampaign && !invitation.hasReview"
                  class="btn_review"
                  sytle="display:none"
                >
                  상품평
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="order_info">
        <div class="item">
          <h5>주문 기본 설정 정보</h5>
          <div class="box type1">
            <div class="tit">환불 계좌</div>
            <div class="txt">
              <div v-if="bankInfo.bankOwner">
                <p>{{ bankInfo.bankName }} {{ bankInfo.bankNumber }}</p>
                <span>{{ bankInfo.bankOwner }}</span>
              </div>
              <div v-else>
                <p>등록된 계좌가 없습니다.</p>
              </div>
              <a @click="$router.push({name: 'AccountManagementPage'})">환불계좌관리</a>
            </div>
          </div>
        </div>
        <div class="item">
          <h5>나의 활동관리</h5>
          <div class="box type2">
            <ul>
              <li>
                <div class="tit">1:1문의내역</div>
                <div class="wrap">
                  <a href="">3건</a>
                </div>
              </li>
              <li>
                <div class="tit">나의상품평</div>
                <div class="wrap">
                  <a href="">0건</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <CreateReviewModal
    v-if="reviewModal"
    @closeModal="closeReviewModal"
    @reviewCreated="requestInvitation"
    :orderNum="selectedOrderNum"
  />
</template>
<script>
import { mapActions, mapState } from "vuex";
import CreateReviewModal from "../common/modals/CreateReviewModal.vue";

const invitationModule = "invitationModule";
const accountModule = 'accountModule'

export default {
  components: {
    CreateReviewModal,
  },

  data() {
    return {
      currentPage: 1,
      daysAgo: 30,

      selectedOrderNum: null,
      reviewModal: false,

      bankInfo: {}
    };
  },

  methods: {
    ...mapActions(invitationModule, ["requestInvitationListByDaysAgo"]),
    ...mapActions(accountModule, ['requestReturnBankInfo']),

    openReviewModal(orderNum) {
      this.selectedOrderNum = orderNum;
      this.reviewModal = true;
    },

    closeReviewModal() {
      this.reviewModal = false;
    },

    requestInvitation() {
      console.log(1111);
      const { currentPage, daysAgo } = this;
      this.requestInvitationListByDaysAgo({ currentPage, daysAgo });
    },

    async getReturnBankInfo() {
        this.bankInfo = await this.requestReturnBankInfo()
    },
  },

  computed: {
    ...mapState(invitationModule, ["invitations", "invitationCount"]),
  },

  async mounted() {
    const { currentPage, daysAgo } = this;
    await this.requestInvitationListByDaysAgo({ currentPage, daysAgo });
    await this.getReturnBankInfo()
  },
};
</script>
